import { get, post } from './http'
import base64 from '../api/base64'
const getEncryptData = (link, data) => {
  if (link.includes('isEncrypt=1')) {
    try {
      data.data = JSON.parse(base64.decode(data.data))
    } catch (e) {}
  }
  return data
}
export default {
  POST(params={},link,self) {
    return new Promise((resolve) => {
      post(params,link,self).then(data => {
        data = getEncryptData(link, data)
        resolve(data)
      })
    })
  },
  GET(params={},link,self) {
    return new Promise((resolve) => {
      get(params,link,self).then(data => {
        data = getEncryptData(link, data)
        resolve(data)
      })
    })
  }
}
